// extracted by mini-css-extract-plugin
export default {"authDialogBody":"auth-dialog-module__authDialogBody___qckGw","authDialogContent":"auth-dialog-module__authDialogContent___oJoBo"};